export default () => (
  /**
   * Ícone matriz 3x3 geralmente utilizado para representar menu.
   * Responsavel por mostrar os modulos disponiveis.
   */
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.00402832 0.599365V4.41755H3.82221V0.599365H0.00402832ZM5.09494 0.599365V4.41755H8.91312V0.599365H5.09494ZM10.1858 0.599365V4.41755H14.004V0.599365H10.1858ZM0.00402832 5.69027V9.50846H3.82221V5.69027H0.00402832ZM5.09494 5.69027V9.50846H8.91312V5.69027H5.09494ZM10.1858 5.69027V9.50846H14.004V5.69027H10.1858ZM0.00402832 10.7812V14.5994H3.82221V10.7812H0.00402832ZM5.09494 10.7812V14.5994H8.91312V10.7812H5.09494ZM10.1858 10.7812V14.5994H14.004V10.7812H10.1858Z"
      fill="#CEDEFF"
    />
  </svg>
);
